import React, { useEffect, useContext } from "react";
import { Card, useAccordionToggle, AccordionContext } from "react-bootstrap";
import "./accordion.css";

/**
 * Accordion Toggle component
 */
const AccordionToggle = ({
    eventKey,
    draggable = "false",
    onDragStart = () => {},
    onDragEnd = () => {},
    onClick = () => {},
    onDoubleClick = () => {},
    className = "",
    style = {},
    children,
}) => {
    let clickCount = 0;

    let timeout = null;
    let timeout2 = null;

    const activeKey = useContext(AccordionContext);
    const isExpanded = Array.isArray(activeKey) 
        ? activeKey.includes(eventKey) 
        : activeKey === eventKey;

    /**
     * Opens and closes the accordion
     */
    const toggleAccordion = useAccordionToggle(eventKey);

    /**
     * Accordion Toggle click handler
     * 
     * toggles accordion & changes active key on single click or
     * calls double click handler on  multiple clicks
     */
    const onClickHandler = (e) => {
        clickCount++;

        clearTimeout(timeout2)
        clearTimeout(timeout);

        timeout = setTimeout(() => {
            if (clickCount === 1) {
                toggleAccordion(e);
                
                timeout2 = setTimeout(() => {
                    onClick();
                });
            } else if (clickCount > 1) {
                onDoubleClick();
            }

            clickCount = 0;
        }, 200);
    };

    useEffect(() => {
        return () => {
            clearTimeout(timeout);
            clearTimeout(timeout2);

            timeout = null;
            timeout2 = null;
        }
    }, []);

    const combinedClassName = `accordion-header ${className} ${isExpanded ? "active" : ""}`.trim();

    return (
        <Card.Header
            draggable={draggable}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onClick={onClickHandler}
            className={combinedClassName}
            style={style}
        >
            {children}
        </Card.Header>
    );
}

export default AccordionToggle;